import React, { useEffect, useState } from 'react';
import { ItemsAPI } from '../../../../api/payments/items/api';
import { DiscountPricePreview } from './DiscountPricePreview';
import { ItemSelect as OfferItemSelect } from '../../../Offers/_components/ItemSelect';

// Mesmo select de itens usado na criação de oferta (busca no servidor em
// /items). `onChange(id, item)` devolve também o item inteiro, pra o pai
// guardar o nome (resumo do form) sem refazer a busca.
export function ItemSelect({
  value,
  valueType,
  discountValue,
  onChange,
  error,
}) {
  const [selected, setSelected] = useState(null);

  // Edição: o item salvo ainda não está carregado; busca-o pra exibir o nome.
  useEffect(() => {
    if (!value) {
      setSelected(null);
      return;
    }
    if (selected?.id === value) return;
    // ignora resposta de um `value` anterior (troca de produto ou unmount)
    let cancelled = false;
    ItemsAPI.get(value)
      .then((response) => {
        if (!cancelled) setSelected(response.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="form-group mb-0">
      <label>Selecione o produto</label>
      <OfferItemSelect
        value={value ? selected : null}
        onChange={(item) => {
          setSelected(item);
          onChange(item ? item.id : '', item);
        }}
      />
      {value && (
        // preço do item (value) já com o desconto, igual à prévia do plano
        <DiscountPricePreview
          plan={selected}
          valueType={valueType}
          value={discountValue}
        />
      )}
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
}
